import React from 'react'

import { decimalPrice } from '../../../../../../../utils'
import { useCurrencyAreaContext } from '../../../../../../contexts'
import { TotalPrice } from '../../../../../../molecules'

interface IUpdateQuoteFooterProps {
  priceWithoutVat: number
  priceWithVat: number
}

const QuoteSectionFooter = ({
  priceWithoutVat,
  priceWithVat,
}: IUpdateQuoteFooterProps) => {
  const { currency } = useCurrencyAreaContext()

  return (
    <TotalPrice
      totalHT={
        priceWithoutVat ? decimalPrice(priceWithoutVat, { currency }) : '-'
      }
      totalTTC={priceWithVat ? decimalPrice(priceWithVat, { currency }) : '-'}
    />
  )
}

export default QuoteSectionFooter
